import displayError from '@/api/errors/errorResponse'
import { loginService } from '@/api/services/auth/authService'
import Logo from '@/assets/logo.svg?react'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '@/components/forms/form/Form'
import FormWrap from '@/components/forms/form/FormWrap'
import { Input } from '@/components/forms/inputs/text/Input'
import PageWrap from '@/components/layout/containers/PageWrap'
import { Seo } from '@/components/specific/seo/Seo'
import paths from '@/router/data/paths'
import useAuthStore from '@/store/userStore'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { z } from 'zod'

const formSchema = z.object({
  email: z.string().email(),
  password: z.string().min(8)
})

function Login() {
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: { email: '', password: '' }
  })
  const fetchUserData = useAuthStore((state) => state.fetchUserData)
  const navigate = useNavigate()

  const onSubmit = async (data: z.infer<typeof formSchema>) => {
    const res = await loginService(data)
    if (!res.success) {
      displayError(res)
      return
    }
    navigate(paths.HOME, { replace: true })
    await fetchUserData()
  }

  return (
    <>
      <Seo title="Logowanie" />
      <PageWrap className="px-2 md:px-0">
        <div className="w-full max-w-lg rounded-3xl bg-white p-0.5 shadow-form">
          <div className="flex flex-col items-center justify-center rounded-t-3xl bg-gradient-to-b from-[#028BA8]/15 to-white p-8">
            <Logo height={60} />
            <h1 className="mt-10 text-3xl font-medium">Zaloguj się</h1>
            <p className="mt-2 text-gray-600">Proszę wprowadzić swoje dane logowania.</p>
          </div>
          <div className="flex w-full flex-col items-center justify-center p-8">
            <Form {...form}>
              <FormWrap
                buttonClassName="w-full"
                onSubmit={form.handleSubmit(onSubmit)}
                submitText="Zaloguj"
              >
                <div className="flex w-full flex-col gap-5 pb-10">
                  <FormField
                    control={form.control}
                    name="email"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Email</FormLabel>
                        <FormControl>
                          <Input
                            placeholder="Wpisz email"
                            type="email"
                            {...field}
                            // error={errors?.email}
                            required
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <FormField
                    control={form.control}
                    name="password"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Hasło</FormLabel>
                        <FormControl>
                          <Input
                            placeholder="Wpisz hasło"
                            type="password"
                            {...field}
                            // error={errors?.email}
                            required
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </div>
              </FormWrap>
            </Form>
          </div>
        </div>
      </PageWrap>
    </>
  )
}

export default Login
